/* eslint-disable  */
//@ts-nocheck
import React, { ReactNode, useEffect, useRef } from 'react';

export const useGetter = <T,>(val: T) => {
  const ref = useRef(val);

  ref.current = val;

  return () => ref.current;
};

export const useMouseDownOutside = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
};

export const StyleChildren = ({
  children,
  ...rest
}: {
  children: ReactNode;
}) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && (rest as any).className) {
      return React.cloneElement(child, { className: (rest as any).className });
    }
    return child;
  });
  return <>{childrenWithProps}</>;
};
